import memoizee from 'memoizee';

export const memoize = memoizee;
